import { createGlobalStyle } from "styled-components";
import * as fonts from "./fonts";
import * as mq from "./mediaQueries";

export const GlobalStyle = createGlobalStyle({
  body: {
    fontFamily: fonts.one,
    "overflow-x": "hidden",
    [mq.sm]: {
      fontSize: "16px",
    },
    "@media (min-width: 1200px)": {
      fontSize: "calc(16 * 100vw / 1440)",
    },
  },
});
